import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';
import {Button2} from '../../styles/components/button.style';

export const BookTableWrapper = styled.div`
  width: 100%;
  text-align: right;
`;

export const BookTableButton = Button2.extend`
  width: 26rem;
  line-height: 1.6rem;
  &:hover {
    background-color: ${props => props.theme.button.hoverColor};
  }
  &:disabled {
    cursor: default;
    background-color: ${props => props.theme.secondaryColor};
    border-bottom: ${props => props.theme.button.primary.borderBottom};
  }
  ${media.small`
    width: 100%;
  `};
`;

export const ButtonText = styled.span`
  line-height: 2.4rem;
`;

export const FormError = styled.div`
  background-color: ${props => props.theme.checkoutPage.formErrorBackground};
  color: ${props => props.theme.checkoutPage.formErrorColor};
  padding: ${props => props.theme.padding};
  margin-top: ${props => props.theme.margin};
`;



// WEBPACK FOOTER //
// ./containers/TableBooking/TableBookingForm.style.js